export interface QuickFiltersT {
  id: number;
  title: string;
  value: string;
}

export const quickFiltersData: Array<QuickFiltersT> = [
  {id: 0, title: 'همه', value: ''},
  {id: 1, title: 'امروز', value: 'period=today'},
  {id: 2, title: '۷ روز اخیر', value: 'period=7days'},
  {id: 3, title: 'یک ماه اخیر', value: 'period=30days'},
  {id: 4, title: 'آرشیو', value: 'period=more'},
];
